

































import {
  Vue, Component, Prop, Watch, Mixins, Emit,
} from 'vue-property-decorator'
import firebase from 'firebase/app'
import MainMixin from '../mixins/MainMixin'


@Component({
  components: {
  },
})

export default class NotAuthorized extends Mixins(MainMixin) {
  logout() {
    firebase.auth().signOut()
  }
}
